import { authGuard } from '@auth0/auth0-vue';
import { RouteNames } from '@/data/routes';

import MainLayout from '@/components/layouts/MainLayout.vue';

import DocumentsListPage from '@/pages/documents/DocumentsListPage.vue';
import { createRoutes } from '@/utils/router-helper';

export default createRoutes({
  path: '/documents',
  component: MainLayout,
  beforeEnter: authGuard,
  meta: {
    requiresAuth: true,
    displayNav: true,
  },
  children: [
    {
      path: '',
      alias: '/pay-vendors/all-documents',
      name: RouteNames.DOCUMENTS.INDEX,
      component: DocumentsListPage,
    },
  ],
});
